import { ExercisePage } from 'pages/Exercise'
import React from 'react'

export default function ViewExercise (props) {
  return (
    <ExercisePage
      {...props}
      isReadOnly
    />
  )
}
